// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class GetDebitCardDetailRequestModel {
    static getAttributeTypeMap() {
        return GetDebitCardDetailRequestModel.attributeTypeMap;
    }
}
GetDebitCardDetailRequestModel.discriminator = undefined;
GetDebitCardDetailRequestModel.attributeTypeMap = [
    {
        "name": "memberNumber",
        "baseName": "memberNumber",
        "type": "string"
    },
    {
        "name": "debitCardAccountNumber",
        "baseName": "debitCardAccountNumber",
        "type": "string"
    },
    {
        "name": "debitCardNumber",
        "baseName": "debitCardNumber",
        "type": "string"
    }
];
//# sourceMappingURL=getDebitCardDetailRequestModel.js.map